"use client";
import React from "react";
import Balancer from "react-wrap-balancer";
import { Link } from "next-view-transitions";
import { Button } from "./button";
import { useTranslations } from "next-intl";

export const CTA = () => {
  const t = useTranslations("cta");

  return (
    <section className="w-full border-t border-neutral-800 bg-black">
      <div className="mx-auto max-w-3xl px-6 py-28 md:py-36 text-center">
        <h2 className="text-balance text-3xl md:text-5xl font-bold tracking-tight text-white">
          {t("heading")}
        </h2>
        <p className="mt-4 mx-auto max-w-xl text-base md:text-lg text-neutral-400">
          <Balancer>{t("body")}</Balancer>
        </p>
        <div className="mt-8 flex justify-center">
          <Button
            as={Link}
            href="/signup"
            className="bg-red-600 hover:bg-red-500 text-white font-semibold px-6 py-3 rounded-full transition-colors"
          >
            {t("button")}
          </Button>
        </div>
      </div>
    </section>
  );
};
